import {useQuery} from 'react-query';

import {contextOrganizationId} from 'src/lib/api/api';
import {H5ObservationDataRequest, fetchH5ObservationData} from 'src/lib/api/h5';
import {Site} from 'src/lib/api/project';

// Organization context is sent in a header, so it must also be part of the cache key.
export function useH5ObservationData(site: Site, request: H5ObservationDataRequest | undefined) {
  return useQuery(
    ['h5ObservationData', contextOrganizationId, site.id, request],
    ({signal}) => fetchH5ObservationData(site.id, request!, {signal}),
    {enabled: !!request, retry: false}
  );
}
